"use client"

import { BookmarkCheck } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `BookmarkCheckIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const BookmarkCheckIcon = component(Icon)({ as: BookmarkCheck })
